export const rootFields = [
  'accountList',
  'accountListCoaches',
  'accountListInvites',
  'accountListPledges',
  'accountListUsers',
  'accountLists',
  'address',
  'addresses',
  'announcements',
  'appeal',
  'appealContacts',
  'appeals',
  'coachingAccountList',
  'coachingAccountListPledges',
  'coachingAccountLists',
  'constant',
  'contact',
  'contactDuplicates',
  'contacts',
  'designationSupportCalculation',
  'designationSupportCalculations',
  'donation',
  'donations',
  'effectiveSalaryRequest',
  'financialAccount',
  'financialAccounts',
  'goalCalculation',
  'goalCalculations',
  'hcm',
  'individualMultiplier',
  'latestAdditionalSalaryRequest',
  'latestSalaryRequest',
  'managedStaff',
  'managedStaffDepartments',
  'managedStaffTeams',
  'ministries',
  'ministryHousingAllowanceRequest',
  'ministryHousingAllowanceRequests',
  'ministryPartnerReminders',
  'monthlyPayrollHistory',
  'monthlyPayrollSummary',
  'newStaffCohort',
  'newStaffCohortAssignableCoaches',
  'newStaffCohorts',
  'newStaffGoalCalculation',
  'newStaffQuestionnaire',
  'newStaffScenarioGoals',
  'notificationPreferences',
  'notificationTypes',
  'organizations',
  'partnerGivingAnalysis',
  'payrollDates',
  'people',
  'person',
  'personDuplicates',
  'quarterlyPayrollHistory',
  'reportsActivityResults',
  'reportsDonationHistories',
  'reportsDonorCurrencyDonations',
  'reportsPeopleWithAnniversaries',
  'reportsPeopleWithBirthdays',
  'reportsSalaryCurrencyDonations',
  'reportsSavingsFundTransfer',
  'reportsStaffExpenses',
  'reportsTagHistories',
  'salaryInfo',
  'salaryRequest',
  'staffAccount',
  'task',
  'tasks',
  'tenure',
  'user',
  'userNotifications',
  'userOption',
  'userOptions',
  'userOrganizationAccounts',
  'acknowledgeAllUserNotifications',
  'acknowledgeAnnouncement',
  'acknowledgeUserNotification',
  'anonymizeContact',
  'apiOauthSignIn',
  'assignCoachToNewStaffCohortAttendee',
  'assignContactsToAppeal',
  'cancelAccountListInvite',
  'completeNewStaffQuestionnaire',
  'createAccountListInvite',
  'createAccountListPledge',
  'createAdditionalSalaryRequest',
  'createAddress',
  'createAppeal',
  'createContact',
  'createDesignationSupportCalculation',
  'createDesignationSupportHoursItem',
  'createDonation',
  'createGoalCalculation',
  'createMinistryHousingAllowanceRequest',
  'createNewStaffScenarioGoal',
  'createOrUpdateUserOption',
  'createOrganizationAccount',
  'createPerson',
  'createRecurringTransfer',
  'createSalaryRequest',
  'createSubBudgetCategory',
  'createTask',
  'createTaskComment',
  'createTasks',
  'createTransfer',
  'deleteAccountListCoach',
  'deleteAccountListPledge',
  'deleteAccountListUser',
  'deleteAdditionalSalaryRequest',
  'deleteAddress',
  'deleteAppeal',
  'deleteAppealContact',
  'deleteContact',
  'deleteDesignationSupportCalculation',
  'deleteDesignationSupportHoursItem',
  'deleteDonation',
  'deleteGoalCalculation',
  'deleteMinistryHousingAllowanceRequest',
  'deleteNewStaffScenarioGoal',
  'deleteOrganizationAccount',
  'deletePerson',
  'deleteRecurringTransfer',
  'deleteSalaryRequest',
  'deleteSubBudgetCategory',
  'deleteTask',
  'deleteTasks',
  'deleteUser',
  'deleteUserOption',
  'duplicateMinistryHousingAllowanceRequest',
  'mergeAccountList',
  'mergePeople',
  'oktaSignIn',
  'previewNewStaffGoalCalculation',
  'printNewStaffCohortGoals',
  'resetAccountList',
  'runAndSendNewStaffCohort',
  'sendNewStaffScenarioGoal',
  'submitAdditionalSalaryRequest',
  'submitMinistryHousingAllowanceRequest',
  'submitSalaryRequest',
  'syncOrganizationAccount',
  'unassignCoachFromNewStaffCohortAttendee',
  'updateAccountList',
  'updateAccountListPledge',
  'updateAdditionalSalaryRequest',
  'updateAddress',
  'updateAppeal',
  'updateBudgetFamily',
  'updateContact',
  'updateContacts',
  'updateDesignationSupportCalculation',
  'updateDesignationSupportHoursItem',
  'updateDonation',
  'updateDonations',
  'updateDuplicate',
  'updateGoalCalculation',
  'updateManagedStaffGeographicLocation',
  'updateMinistryHousingAllowanceRequest',
  'updateMinistryPartnerReminders',
  'updateNewStaffCohort',
  'updateNewStaffGoalCalculation',
  'updateNewStaffQuestionnaire',
  'updateNotificationPreferences',
  'updateOrganizationAccount',
  'updatePeople',
  'updatePerson',
  'updatePreference',
  'updatePrimaryBudgetCategory',
  'updateRecurringTransfer',
  'updateSalaryRequest',
  'updateSubBudgetCategory',
  'updateTask',
  'updateTasks',
  'updateUser',
  'updateUserGeographicLocation',
  'userKeySignIn',
];
